import ApplicationController from './application_controller'
import bootstrap from "bootstrap/dist/js/bootstrap.js"
import { createPopper } from '@popperjs/core';

// use with: data-controller='tooltip' data-bs-title='Content of Tooltip' data-bs-toggle='tooltip' data-bs-html='true' data-bs-placement='bottom'
// documentation: https://getbootstrap.com/docs/5.3/components/tooltips/#overview

export default class extends ApplicationController {

	connect() {
		// remove default "focus" trigger to fix element clicks from making a "stuck" tooltip on focus
		const config = { trigger: 'hover' }
		const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.element, config)

		tooltip.enable()
	}	

	disconnect() {
		const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.element)
		tooltip.disable()
	}

}
